<template>
  <md-list-item>
    <template v-if="file.isNew">
      <div class="md-list-text-container">
        <md-input-container>
          <label>File Name</label>
          <md-input required v-model="file.name" autofocus></md-input>
        </md-input-container>
      </div>
      <md-button class="md-icon-button md-list-action" @click="createFile" style="flex: 0;">
        <md-icon v-if="createStatus === ''" class="status-icon md-primary">done</md-icon>
        <md-icon v-if="createStatus === 'pending'" class="status-icon md-primary pending">refresh</md-icon>
        <md-icon v-if="createStatus === 'error'" class="status-icon md-primary error">error</md-icon>
      </md-button>
    </template>
    <template v-else>
      <md-button class="md-icon-button md-list-action delete-btn" :class="{ error: deleteStatus === 'error' }" @click="deleteFile" style="flex: 0;">
        <md-icon v-if="deleteStatus === 'pending'" class="status-icon md-primary pending">refresh</md-icon>
        <md-icon v-else="" class="md-primary">delete</md-icon>
      </md-button>
      <div class="md-list-text-container">
        <span class="name">{{ file.name }}</span>
        <span class="parents">{{ computedParents }}</span>
      </div>
      <md-icon v-if="saveStatus === 'pending'" class="md-primary status-icon pending">refresh</md-icon>
      <md-icon v-if="saveStatus === 'success'" class="md-primary status-icon success">cloud_done</md-icon>
      <md-icon v-if="saveStatus === 'error'" class="md-primary status-icon error">error</md-icon>
      <md-button class="md-icon-button md-list-action" @click="triggerEditFile" style="flex: 0;">
        <md-icon class="md-primary">edit</md-icon>
      </md-button>
    </template>
  </md-list-item>
</template>

<script>
  import Vue from 'vue';

  export default {
    name: 'driveFileListItem',

    props: ['file'],

    data() {
      return {
        parents: [],
        /**
         * save, create, delete status.
         * Each status value may be:
         *   - ''
         *   - 'pending'
         *   - 'success' (saveStatus only)
         *   - 'error'
         */
        saveStatus: '',
        createStatus: '',
        deleteStatus: '',
      };
    },

    computed: {
      computedParents() {
        if (this.parents && this.parents.length > 0) {
          return this.parents.reverse().join(' / ');
        }
        return '';
      },
    },

    mounted() {
      this.parents = [];
      this.createStatus = '';
      this.saveStatus = '';
      this.deleteStatus = '';
      if (this.file.parents && this.file.parents.length > 0) {
        this.getParents(this.file.parents);
      }
      this.$events.on('editor-pending-save', (file, pending, response) => {
        if (file.id === this.file.id) {
          this.saveStatus = pending ? 'pending' : '';
          if (response) {
            this.saveStatus = response.status === 200 ? 'success' : 'error';
          }
        }
      });
    },

    methods: {
      getParents(parentIds = []) {
        parentIds.forEach((parentId) => {
          Vue.googleDrive.file(parentId).then((response) => {
            if (response.status === 200 && response.result) {
              this.parents.push(response.result.name);
              if (response.result.parents && response.result.parents.length > 0) {
                this.getParents(response.result.parents);
              }
            }
          });
        });
      },

      createFile() {
        if (this.file.name !== '') {
          this.createStatus = 'pending';
          Vue.googleDrive.saveFile(this.file, `# ${this.file.name}`).then((response) => {
            if (response.status === 200) {
              this.createStatus = '';
              Object.assign(this.file, response.result);
              this.file.isNew = false;
              this.parents = [];
              this.getParents(this.file.parents);
            } else {
              this.createStatus = 'error';
            }
          });
        }
      },

      triggerEditFile() {
        this.file.isNew = undefined;
        this.$events.emit('edit-file', this.file);
      },

      deleteFile() {
        this.deleteStatus = 'pending';
        Vue.googleDrive.delete(this.file.id).then((response) => {
          if (response.status === 204) {
            this.$events.emit('file-delete', this.file);
          } else {
            this.deleteStatus = 'error';
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../assets/theme';
</style>


// WEBPACK FOOTER //
// src/components/DriveFileListItem.vue?2ca39fb1